"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M31.737 34.212c2.624-.535 8.138-3.266 8.138-11.725 0-8.995-6.05-14.4-14.4-14.4C16 8.084 8.286 14.455 8.286 26.073c0 8.085 3.641 13.653 10.012 16.919a.513.513 0 0 1 .268.482l-.107 3.534c0 .268-.054.268-.268.214C9.731 43.9 4.217 36.3 4.217 26.288 4.217 13.652 13 4.55 25.633 4.55c10.066 0 18.15 6.532 18.15 17.615 0 10.869-7.978 16.169-17.08 16.169-7.067 0-11.94-3.962-11.94-11.618a12.152 12.152 0 0 1 12.476-12.582 14.239 14.239 0 0 1 5.354.857c.214.054.268.107.268.321zM28.9 17.828a7.183 7.183 0 0 0-2.2-.268c-4.926 0-8.031 3.908-8.031 8.834 0 4.658 2.463 8.352 7.6 8.352a6.636 6.636 0 0 0 1.66-.161z" })
);

